export function hasChildrenProduct(item) {
	return !!(item && item.childrenProduct && item.childrenProduct.length > 0);
}

export function hasProductDetail(item) {
	const pic = item && (item.bigPicSJ || item.bigPic || item.midPic);
	return !!pic && String(pic).trim() !== '';
}

export function canNavigateFromSecItem(item) {
	if (!hasChildrenProduct(item)) {
		return false;
	}

	const child = item.childrenProduct[0];
	const jumpnum = child.level - item.level;

	if (jumpnum > 1) {
		return hasProductDetail(child);
	}

	return true;
}

export function canNavigateFromThirdItem(item) {
	return hasProductDetail(item);
}
